<template>
  <el-drawer
    size="60%"
    ref="drawer"
    :title="title"
    :with-header="true"
    :visible.sync="drawer"
    :before-close="resetForm"
  >
    <el-container direction="vertical">
      <el-main>
        <el-row :gutter="20">
          <el-col :span="24">
            <el-form
              ref="companyForm"
              v-loading="loading"
              size="mini"
              label-width="150px"
              label-position="left"
              :model="companyData"
            >
              <el-row :gutter="20">
                <el-col :span="12">
                  <el-form-item label="Codigo">
                    <el-input
                      v-model="companyData.Code"
                      :disabled="true"
                    ></el-input>
                  </el-form-item>

                  <el-form-item label="Contacto">
                    <el-input
                      v-model="companyData.Contact"
                      :disabled="isView"
                    ></el-input>
                  </el-form-item>

                  <el-form-item label="Main Address">
                    <el-input
                      v-model="companyData.Address1"
                      :disabled="isView"
                    ></el-input>
                  </el-form-item>

                  <el-form-item label="Address 2">
                    <el-input
                      v-model="companyData.Address2"
                      :disabled="isView"
                      placeholder="Address 2"
                    ></el-input>
                  </el-form-item>

                  <el-form-item label="Database Name">
                    <el-input
                      v-model.trim="companyData.CompanyDatabaseName"
                      :disabled="isView"
                    ></el-input>
                  </el-form-item>

                  <el-form-item label="Integration Portal">
                    <el-radio-group
                      v-model="companyData.IntegrationPortal"
                      :disabled="isView"
                    >
                      <el-radio :label="true">Si</el-radio>
                      <el-radio :label="false">No</el-radio>
                    </el-radio-group>
                  </el-form-item>
                </el-col>

                <el-col :span="12">
                  <!-- <el-form-item label="Creation Date">
                    <el-date-picker
                      type="date"
                      placeholder="Pick a date"
                      v-model="companyData.CreatedAt"
                      style="width: 100%;"
                      :disabled="isView"
                    ></el-date-picker>
                  </el-form-item> -->

                  <el-form-item label="Name">
                    <el-input
                      v-model="companyData.Name"
                      :disabled="isView"
                      placeholder="Company Name"
                    ></el-input>
                  </el-form-item>

                  <el-form-item label="Email">
                    <el-input
                      v-model="companyData.Name"
                      :disabled="isView"
                      placeholder="Company Email"
                    ></el-input>
                  </el-form-item>

                  <el-form-item label="Phone Number">
                    <el-input
                      v-model="companyData.Telephone1"
                      :disabled="isView"
                    ></el-input>
                  </el-form-item>

                  <el-form-item label="Phone Number 2">
                    <el-input
                      v-model="companyData.Telephone2"
                      :disabled="isView"
                      placeholder="Phone Number 2"
                    ></el-input>
                  </el-form-item>

                  <el-form-item label="Secret Key">
                    <el-input
                      v-model="companyData.SecretKey"
                      :disabled="isView"
                      placeholder="Secret Key"
                    ></el-input>
                  </el-form-item>
                </el-col>
              </el-row>

              <el-form-item label="" label-width="0">
                <el-button
                  v-if="!isView"
                  type="primary"
                  v-loading="loading"
                  @click="onSubmit"
                  >{{ btnSummit }}</el-button
                >
                <el-button @click="resetForm()">Cancel</el-button>
              </el-form-item>
            </el-form>
          </el-col>
        </el-row>
      </el-main>
    </el-container>
  </el-drawer>
</template>

<script>
export default {
  name: "NewCompany",
  data() {
    return {
      drawer: false,
      btnSummit: "Save",
      loading: false,
      innerDrawer: false,
      direction: "rtl",
      companyCode: "",
      title: "",
      isView: false,
      isEdit: false,
      commandAction: "",
      editCompanyData: {},
      companyData: {}
    };
  },

  methods: {
    showCompany(data, title, isView, isEdit) {
      this.companyCode = this.uuidv4();
      this.title = title;
      this.isView = isView;
      this.isEdit = isEdit;
      this.companyData.Code = this.companyCode;
      // this.companyData.IntegrationPortal = false;
      this.drawer = data;
    },
    editCompany(data, title, isView, isEdit) {
      this.editCompanyData = data;
      this.btnSummit = "Editar";
      this.title = title;
      this.isView = isView;
      this.isEdit = isEdit;
      this.companyData = this.editCompanyData.row;
      this.drawer = true;
    },

    resetForm() {
      this.companyData = {};
      this.drawer = false;
    },

    uuidv4() {
      return ([1e7] + -1e3 + -4e3 + -8e3 + -1e11).replace(/[018]/g, (c) =>
        (
          c ^
          (crypto.getRandomValues(new Uint8Array(1))[0] & (15 >> (c / 4)))
        ).toString(16)
      );
    },
    onSubmit() {
      this.$refs.companyForm.validate((valid) => {
        if (valid) {
          this.commandAction = this.editCompanyData.command ?? "adCompany";
          this.loading = true;

          if (this.commandAction == "editCompany") {
            this.onEditCompany();
          } else {
            this.$http
              .post("/api/companies/add", this.companyData)
              .then(() => {
                this.$refs.companyForm.resetFields();
                this.isDrawer = false;
                this.$message.success("Company created Sucessfully.");
              })
              .catch(() => {
                this.$message.error("Error Trying Create Company.");
              })
              .finally(() => {
                this.loading = false;
              });
          }
        } else {
          return false;
        }
      });
    },
    onEditCompany() {
      this.$refs.companyForm.validate((valid) => {
        if (valid) {
          this.loading = true;

          this.$http
            .put(`/api/companies/${this.companyData.Id}`, this.companyData)
            .then(() => {
              this.$refs.companyForm.resetFields();
              this.isDrawer = false;
              this.companyData = {};
              this.drawer = false;
              this.$message.success("Company Updated Sucessfully.");
            })
            .catch((error) => {
              console.error(error);
              this.$message.error("Error Trying Update Company.");
            })
            .finally(() => {
              this.loading = false;
            });
        } else {
          return false;
        }
      });
    }
  }
};
</script>

<style></style>
